const types = {
  sell: 'ทองขาย',
  old: 'ทองเก่า',
  fill: 'เติมทอง'
}

export const getType = type => types[type]
